import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75abcbaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ant-row ss-margin-campos" }
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_3 = {
  key: 0,
  class: "ss-campos-selecionados"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ss-label-reordernar" }, "Arraste para reordenar os campos:", -1))
const _hoisted_5 = { class: "ss-campos-container" }
const _hoisted_6 = ["onDragstart", "onDrop"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-drag-handle" }, "⋮⋮", -1))
const _hoisted_8 = { class: "ss-campo-nome" }
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_form_item, {
        label: "Campos do Relatório",
        class: "ss-margin-campos"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_select, {
            value: _ctx.novosCampos,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.novosCampos) = $event)),
            mode: "multiple",
            style: {"width":"100%"},
            placeholder: "Selecione os campos (ex: Status, ProdutoAcabado...)",
            options: _ctx.opcoesDisponiveis,
            "filter-option": _ctx.filtrarOpcoes,
            "max-tag-count": 20,
            "allow-clear": ""
          }, null, 8, ["value", "options", "filter-option"])
        ]),
        _: 1
      }),
      (_ctx.camposSelecionados.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.camposSelecionados, (campo, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: campo + '-' + index,
                  class: "ss-campo-item",
                  draggable: "true",
                  onDragstart: ($event: any) => (_ctx.iniciarDrag($event, index)),
                  onDragover: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.dragoverCampo($event)), ["prevent"])),
                  onDrop: ($event: any) => (_ctx.soltarCampo($event, index)),
                  onDragend: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.finalizarDrag && _ctx.finalizarDrag(...args)))
                }, [
                  _hoisted_7,
                  _createElementVNode("span", _hoisted_8, _toDisplayString(campo), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "ss-remover-btn",
                    onClick: ($event: any) => (_ctx.removerCampo(index)),
                    title: "Remover campo"
                  }, " ✕ ", 8, _hoisted_9)
                ], 40, _hoisted_6))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}